import { EntityService } from '@/services/EntityService';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';

export class PersonsService extends EntityService {
  static get entity() {
    return 'persons';
  }

  static async getFilteredPersons(parameters = {}) {
    const params = { ...parameters };

    try {
      const response = await this.request({
        auth: true
      }).get(`/filters/${this.entity}/list`, { params });
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getSharedDocumentsDirs({ personId }) {
    try {
      const response = await this.request().get(
        `${this.entity}/${personId}/shared-documents/dirs`
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async getSharedDocumentsByDir({ personId, dirId }) {
    try {
      const response = await this.request().get(
        `${this.entity}/${personId}/shared-documents/dirs/${dirId}`
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
  static async destroySharedDocument({ personId, documentId }) {
    try {
      const response = await this.request().delete(
        `${this.entity}/${personId}/shared-documents/${documentId}`
      );

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getWelcomeLetterPdf(personId, parameters = {}) {
    const params = { ...parameters };

    try {
      return await this.request({
        auth: true
      }).get(`/${this.entity}/${personId}/welcome-letter`, {
        params,
        responseType: 'arraybuffer'
      });
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getPersonalInfoPdf(personId, parameters = {}) {
    const params = { ...parameters };

    try {
      return await this.request({
        auth: true
      }).get(`/${this.entity}/${personId}/personal-info`, {
        params,
        responseType: 'arraybuffer'
      });
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
